export function transformConfigRestoreForm(formState) {
    var _a;
    if (!formState.file)
        return null;
    var request = { file: formState.file };
    if ((_a = formState.password) === null || _a === void 0 ? void 0 : _a.length)
        request.password = formState.password;
    return request;
}
